<template>
  <history-form mode="edit"></history-form>
</template>

<script>
import VersionHistoryForm from "./VersionHistoryForm.vue";
export default {
  name: "VersionEdit",
  components: {
    HistoryForm: VersionHistoryForm,
  },
};
</script>
